import { useContext, useEffect } from "react";
import useToast from "../../hooks/useToast";
import Toast from "./Toast";
import AppContext from "../../utils/AppContext";

export default function GlobalToast() {
  const [state, dispatch] = useContext(AppContext);
  const { toast, showToast, hideToast } = useToast();

  const { globalToast } = state;

  useEffect(() => {
    if (globalToast) {
      dispatch({ type: "globalToast/clear" });
      showToast(globalToast.message);
    }
  }, [globalToast, dispatch, showToast]);

  return (
    <Toast toast={toast} onHide={hideToast} />
  );
}
